module.exports = __webpack_public_path__ + "static/media/back-arrow-header.b196f65c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/back-arrow-header.svg
// module id = 289
// module chunks = 0